import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../shared/api';
import { CommonService } from '../shared/common.service';
import { Storage } from '@ionic/storage';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {
  @Output() updateVar = new EventEmitter<any>();
  action: string = '';
  id: string = '';
  user: any = null;

  search: string = '';

  area: any = {
    content: ['time-log' /* , 'statistic', 'ordermodule', 'messages' */],
    aside: [/* 'termin', 'chatlist', 'messages' */],
  }

  constructor(
    public commonService: CommonService,
    public route: ActivatedRoute,
		private api: ApiService,
    private storage: Storage,
  ) {
    this.storageCreate();
    this.user = commonService.getUser();
  }

  ngOnInit() {
    this.action = this.route.snapshot.params.action || '';
    this.id = this.route.snapshot.params.id || '';

    // this.getContactData();
    // this.getChatForCustomer('andreas.helm@die.app','X5FM6WVY');
  }

  getContactData() {
    this.api.getContactData().subscribe(
      (res) => {
        let contactArray = res || [];
        console.log(43, contactArray);
      },
      (error) => {
        console.error(43, 'Get contact data', error);
      }
    );
  }
  getChatForCustomer(email, orderHash) {
    this.api.getChatForCustomer(email, orderHash).subscribe(
      (res) => {
        let chats = res || [];
        console.log(56, chats)
      },
      (error) => {
        console.error(56, 'getChatForCustomer', error);
      })
  }

  async storageCreate() {
    await this.storage.create();


  }

}
